import React from 'react';
import { Loader2, X } from 'lucide-react';
import { Button } from '../../../ui/button';
import { Card } from '../../../ui/card';

const MemberHardDeleteModal = ({
  show,
  memberToHardDelete,
  hardDeleting,
  handleHardDeleteMember,
  onClose,
}) => {
  if (!show || !memberToHardDelete) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
      <Card className="w-full max-w-md border-[#2a2a32] bg-[#1e1e24] p-6">
        <div className="mb-4 flex items-center justify-between">
          <h3 className="text-lg font-semibold text-red-400">Permanently delete dad</h3>
          <button onClick={onClose} className="text-gray-400 hover:text-white">
            <X className="h-5 w-5" />
          </button>
        </div>
        <p className="mb-3 text-sm text-gray-400">
          Permanently delete <span className="font-medium text-white">{memberToHardDelete.name}</span>?
          This cannot be undone. They will be removed from Supabase (cannot log in) and from the
          dads list.
        </p>
        <div className="flex gap-3">
          <Button
            variant="outline"
            onClick={onClose}
            className="flex-1 border-[#2a2a32] text-white hover:bg-[#16161a]"
          >
            Cancel
          </Button>
          <Button
            onClick={handleHardDeleteMember}
            disabled={hardDeleting}
            className="flex-1 bg-red-600 text-white hover:bg-red-700"
          >
            {hardDeleting ? <Loader2 className="h-4 w-4 animate-spin" /> : 'Permanently delete'}
          </Button>
        </div>
      </Card>
    </div>
  );
};

export default MemberHardDeleteModal;
